import { Receipt } from "./Receipt";

const FEATURES = [
  {
    num: "i.",
    title: "Bookkeeping & trial balance",
    description: "Every transaction posted to the right account, every period closed on time. Trial balance, P&L, and balance sheet - generated on demand and balanced to the cent."
  },
  {
    num: "ii.",
    title: "Payables & receivables, handled",
    description: "Invoices drafted, sent, and chased. Supplier bills captured, matched to POs, and queued for approval. Aging reports the moment you ask - not next Tuesday."
  },
  {
    num: "iii.",
    title: "Smart reconciliation",
    description: "Pattern-matching that learns how your business moves money. Recurring suppliers, payroll batches, Stripe fee splits - all matched automatically. Edge cases surface in Slack with a one-tap fix."
  },
  {
    num: "iv.",
    title: "An advisor who doesn't bill in 6-min increments",
    description: "Ask anything: pricing, hiring, margins, whether that supplier invoice looks off. Plain-English answers, grounded in your actual numbers - instantly."
  },
];

export function Features() {
  return (
    <section className="features">
      <div className="container">
        <div className="section-head">
          <div>
            <div className="section-num">&#167; 02 - The fine print</div>
            <h2 className="section-title">Real accounting. <em>Done quietly.</em></h2>
          </div>
        </div>

        <div className="features-grid">
          <ul className="features-list">
            {FEATURES.map((feature, idx) => (
              <li key={idx} className="feature-item">
                <div className="feature-num">{feature.num}</div>
                <div className="feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </li>
            ))}
          </ul>

          <Receipt />
        </div>
      </div>
    </section>
  );
}
